<template>
  <div>
    <div style="position:absolute;left:10px;bottom:10px;z-index:99999;" v-show="log_visible">{{log_text}}</div>
    <!-- ***** WATERMARK -->
    <div v-if="watermark_visible" class="watermark" :style="'top:' + ((set_pad_h.replace('px', '') / 2) - 20)+'px'" @click="watermark_visible=false" @touchmove="watermark_visible=false">
      <span
        @mouseenter="watermark_visible=false"
        style="display:inline-block;padding-left:5px;padding-right:5px;"
        ref="watermark_text">Zde vytvořte svůj podpisový vzor. Začněte psát prstem nebo pomocí touchpadu anebo myši.</span>
    </div>
    <!-- ***** NASTROJOVA LISTA: tlacitka, musi byt v-show!!! -->
    <transition name="fade">
      <div v-show="tool_visible" :style="'margin:auto;width:' + set_pad_w" id="toolPanel" ref="toolPanel" @click="clickToolPanel">
        <div
          ref="tool"
          class="tool"
          v-show="tool_visible">
          <el-row>
            <el-col :span="8" style="text-align:left;height:44px;">
              <el-color-picker
                ref="colorPicker"
                style="margin-top:5px;"
                v-model="penColor"
                color-format="hex"
                :active-change="changePenColor()"
                :predefine="predefineColors">
              </el-color-picker>
            </el-col>
            <el-col :span="8" style="line-height:44px">
              <el-button :loading="loading_btn" type="success" :disabled="progress_sign<100" @click="saveSign()" title="Podepsat">Podepsat</el-button>
            </el-col>
            <el-col :span="8" style="text-align:right;line-height:44px">
              <el-button type="primary" circle title="O krok zpět" @click="undo"><i class="fas fa-undo"></i></el-button>
              <el-button type="primary" circle title="Vygumovat podpis a nakreslit znovu" @click="clear"><i class="fas fa-eraser"></i></el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </transition>
    <!-- ***** CANVAS -->
    <div
      @click="mouseClickDown"
      @touchmove="mouseClickDown"
      @touchend="mouseClickUp"
      @mouseup="mouseClickUp">
        <VueSignaturePad
          v-if="signature_visible"
          id="signature"
          ref="xsignaturePad"
          :width="set_pad_w"
          :height="set_pad_h"
          :options="options"
          :customStyle="signStyle"
        />
    </div>
    <!-- ***** INFO LISTA: progress -->
    <transition name="fade">
      <div v-show="info_visible" :style="'margin:auto;width:' + set_pad_w">
        <div
          ref="info"
          class="info"
          v-show="info_visible">
          <el-progress
            :show-text="false"
            :percentage="progress_sign"
            :color="progress_sign < 30 ? '#E6A23C' : '' || progress_sign >= 100 ? '#67C239' : ''"
            style="width:100%">
          </el-progress>
        </div>
      </div>
    </transition>
    <!-- ***** TIP: zobrazi tip o otoceni mobilu -->
    <div v-if="tip01_visible" :style="'margin:auto;width:100%;margin-top:10px;'">
      <div role="alert" class="el-alert el-alert--warning is-light" style="height:120px">
        <i class="el-alert__icon is-big">
          <i class="fas fa-mobile" style="font-size:38px;text-shadow: -1px 0 #aa6005, 0 1px #aa6005, 1px 0 #aa6005, 0 -1px #aa6005;"></i>
        </i>
        <div class="el-alert__content">
          <span class="el-alert__title is-bold" style="font-size:24px">Náš TIP</span>
          <p class="el-alert__description" style="font-size:16px">Otočením vašeho zařízení získáte více prostoru pro váš podpis.</p>
          <!-- <i class="el-alert__closebtn el-icon-close"></i> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable brace-style */
/* eslint-disable one-var */
/* eslint-disable standard/object-curly-even-spacing */
// import vueSignature from 'vue-signature'
import VueSignaturePad from 'vue-signature-pad'
import validity from '@/components/HMEmployeeForm/mixins/validity'

export default {
  name: 'WebForm',
  mixins: [validity],
  props: ['loading_btn'],
  components: {
    VueSignaturePad
  },
  data () {
    return {
      signature_visible: false,
      log_visible: false,
      log_text: '',
      set_pad_w: '99%', // defaultne na velkych rozliseniach je 80%, u mobilov atd, ak je rozlisenie sirky mensie ako 900px, nastavi sa na 100%
      get_pad_w: 760, // sem sa uklada sirka canvasu v pixeloch, pri zmenene velkosti canvasu, nasledne sa podla tejto hodnoty prepocita vyska. Defaultne na PC je sirka canvasu 80%.
      set_pad_h: '350px', // vyska canvasu v pixeloch prepocitana na zaklade get_pad_w
      do_calculate: false, // ak true, zareaguje watch a spusta sa prepocet

      penColor: '#000cff', // komponenta na vyber farby
      options: {
        penColor: '#000cff', // kompononta signature, akou farbou sa bude kreslit
        backgroundColor: 'rgb(255, 255, 255, 0)', // posledne cislo urcuje silu priehladnosti
        minWidth: 2.4,
        maxWidth: 3.0
      },
      signStyle: {
        margin: 'auto',
        border: '1px dashed #dddddd',
        backgroundColor: 'whitesmoke'
      },
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        '#c72577'
      ],
      is_allow_save: true, // nastavi sa na true ak je nakresleny minimalnu pocet bodov do canvasu
      size_of_clear: undefined,
      progress_sign: 0,
      orientation_angle: 0,
      tip01_visible: false,
      watermark_left: 0,
      watermark_visible: true, // ked je canvas prazdny, zobraz
      tool_class: 'tool', // ak je mobil na lezato, prida sa css floating-tool do tool listy
      tool_visible: true, // ak je mobil na lezato a mouseClickDown, tool lista sa schova a po uvolneni clicku sa zase sam objavi
      info_visible: false, // ak je mobil na lezato a mouseClickDown, info lista sa objavi a po uvolneni clicku sa zase sama schova
      info_timeout: undefined // sem sa len uklada settimout aby si pri kliknuti mohol vzdy vynulovat a odpocet tak zacal od zaciatku
    }
  },
  watch: {
    do_calculate: function (newVal) {
      if (newVal === true) {
        let screen_width = window.innerWidth
        this.set_pad_w = screen_width > 900 ? '80%' : '100%'
        let client_width = this.$refs.xsignaturePad ? this.$refs.xsignaturePad.$refs.signaturePadCanvas.clientWidth : window.innerWidth
        this.get_pad_w = this.set_pad_w === '100%' ? screen_width : client_width // zmenou this.get_pad_w sa aktivuje watch a spusti prepocet pre height
        // console.log('window.innerWidth:', window.innerWidth, 'set_pad_w', this.set_pad_w, 'get_pad_w', this.get_pad_w, 'set_pad_h', this.set_pad_h)
      }
      this.do_calculate = false
    },
    get_pad_w: function (new_width) {
      this.getPadHeight()
    },
    orientation_angle: function (newAngle) {
      this.info_visible = newAngle === 0 ? true : false // ak je mobil na lezato, info panel sa auto-schovava, inak je vzdy viditelny
    },
    log_visible: function (newVal) {
      if (newVal === true) {
        setTimeout(() => {
          this.log_visible = false
        }, 5000)
      }
    }
  },
  mounted () {
    console.log('.::. signature.vue mounted .::.')
  },
  created () {
    // var _ = require('lodash')
    console.log('')
    console.log('')
    console.log('.::. signature.vue created .::.')
    console.log(':. window.devicePixelRatio =>', window.devicePixelRatio)

    var _this = this

    // inicializacia...
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been re-rendered
      console.log('.::. --- INICIALIZACIA --- .::.')
      if (window && window.screen && window.screen.orientation) {
        window.screen.orientation.addEventListener('change', function () { // nepodporuje safari ani safari ios, do buducna by mali, zatial pouzijem iOSangleHack
          // *** POZOR !!! Tu nepouzivat this, ale _this !!!
          _this.orientationByDevice(window.screen.orientation.angle)
        })
      }
      window.addEventListener('resize', () => {
        let is_ios = false
        if (navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
          // iPad or iPhone
          is_ios = true
        }
        if (is_ios) { // hack pre iOS
          _this.iOSangleHack()
        }
        else {
          _this.do_calculate = true
        }
      })

      let is_ios = (navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) ? true : false
      if (is_ios) { // hack pre iOS
        _this.iOSangleHack()
      } else {
        this.orientation_angle = window.screen.orientation.angle
      }
      this.orientationByDevice(this.orientation_angle)
      this.info_visible = this.orientation_angle === 0 ? true : false // ak je mobil na lezato, info panel sa auto-schovava, inak je vzdy viditelny
      this.signature_visible = true
      console.log('.::. --- xINICIALIZACIAx --- .::.')
    })
  },
  methods: {
    showLog (p_text) {
      this.log_text = p_text
      this.log_visible = true
    },
    iOSangleHack () {
      console.log('iOSangleHack')
      let result = 0
      // if (!window.orientation) {
      if (window.innerWidth > window.innerHeight) {
        result = 90
      } else {
        result = 0
      }
      this.orientation_angle = result
      this.orientationByDevice(result)
      return result
      // }
    },
    orientationByDevice (p_angle) {
      let _this = this
      _this.orientation_angle = p_angle
      if (_this.$refs.tool) {
        if (_this.orientation_angle === 0) {
          _this.$refs.tool.className = 'tool'
          _this.$refs.info.className = 'info'
        } else {
          _this.$refs.tool.className = 'tool floating-tool'
          _this.$refs.info.className = 'info floating-info'
        }
      }
      // ak bol mobil na lezato a bol zapocaty timeout na schovanie info panelu, zrus ten timeout
      if (_this.info_timeout) {
        clearTimeout(_this.info_timeout)
      }
      _this.do_calculate = true
      var is_mobile = _this.isMobile()
      _this.tip01_visible = is_mobile && _this.orientation_angle === 0 ? true : false
    },
    isMobile () {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    },
    clickToolPanel (e) {
      if (e.target.tagName.toLowerCase() === 'div') { // schovaj tool panel ak sa klikne na listu, v pripade tlacitko zostane viditelny
        this.hideToolPanel()
      }
    },
    mouseClickUp () {
      this.tool_visible = true
      if (this.orientation_angle !==0) { // schovvaj info panel iba v pripade, ze mobil je na lezato
        this.info_timeout = setTimeout(() => {
          this.info_visible = false
        }, 2500)
      }
    },
    mouseClickDown () {
      this.watermark_visible = false // schovaj watermark
      if (this.info_timeout) {
        clearTimeout(this.info_timeout)
      }
      this.hideToolPanel()
      this.computePercentageSign()
    },
    hideToolPanel () {
      if (this.orientation_angle >= 90) { // ak je mobil na lezato, schovaj tool listu a zobraz info panel
        this.tool_visible = false
        if (this.progress_sign < 100) { // zobraz info panel, ak progresbar je mensi ako 100%
          this.info_visible = true
        }
      }
    },
    getPadHeight () {
      try {
        let perc = ((this.get_pad_w / 760) * 100) - 100 // o kolko percent zvacsim/zmensim height od zakladu 350, zakladne rozlisenie 760x350
        this.set_pad_h = 350 * perc
        let vyn = perc < 0 ? 0 : 1
        let zero = perc > -10 && perc < 10 ? 0 : ''
        let nas = vyn + '.' + zero + perc.toString().replace('.', '').replace('-', '') // ak sa zmensuje bude sa nasobit 0.234 ak sa zvacsuje tak 1.234
        let result = (350 * parseFloat(nas))
        result = vyn === 0 ? (350 - result) : result // v pripade ze sa zmensuje, treba este odpocitat od zakladu 350
        result = perc > 100 ? (350 + result) : result // v pripade ze sa zvacsuje o raz a viac tolko, treba pripocitat k zakladu 350
        this.set_pad_h = result.toString() + 'px'
      } catch (err) {
        console.log('ERR!!!', err)
      }
    },
    changePenColor () {
      if (this.$refs.xsignaturePad && this.$refs.xsignaturePad.signaturePad) {
        this.$refs.xsignaturePad.signaturePad.penColor = this.penColor
      }
    },
    computePercentageSign () {
      let size_of_signature = 0 // spocita body v podpise
      for (let index = 0; index < this.$refs.xsignaturePad.toData().length; index++) {
        const row = this.$refs.xsignaturePad.toData()[index]
        size_of_signature += row.points ? row.points.length : 0
      }
      let min_size = 25 // minimalna velkost podpisu, napriklad 35 points
      let percentage = Math.abs((100 / min_size) * size_of_signature) // minus velkost prazdneho canvasu
      percentage = percentage >= 100 ? 100 : percentage
      percentage = percentage <= 0 ? 0 : percentage
      this.progress_sign = percentage
      if (size_of_signature > min_size) {
        this.is_allow_save = false
      }
    },
    clear () {
      var _this = this
      _this.$refs.xsignaturePad.clearSignature()
      this.is_allow_save = this.$refs.xsignaturePad.isEmpty()
      this.computePercentageSign()
      if (this.is_allow_save) {
        this.progress_sign = 0
        this.watermark_visible = true
      }
    },
    undo () {
      var _this = this
      _this.$refs.xsignaturePad.undoSignature()
      this.is_allow_save = this.$refs.xsignaturePad.isEmpty()
      this.computePercentageSign()
      if (this.is_allow_save) {
        this.progress_sign = 0
        this.watermark_visible = true
      }
    },
    saveSign () {
      let png = this.$refs.xsignaturePad.saveSignature()
      this.$emit('saveSign', {type: 'png', img: png})
    }
  }
}
</script>

<style>
  body {
    margin: 0px;
    background-color: #eaeaea;
    background: -webkit-gradient(linear, left top, left bottom, from(#cbccc8), to(#fff)) fixed;
  }
  .tool {
    margin-left: 1px;
    padding-left:10px;
    padding-right:10px;
    width:calc(100% - 2px);
    background: #fcfcfc;
    opacity: 0.99;
  }
  .floating-tool {
    position:absolute;
    top: 0px;
    left:0px;
  }
  .info {
    margin-left: 1px;
    width:calc(100% - 2px);
    background: #FFFFFF;
    opacity: 0.99;
  }
  .floating-info {
    position:absolute;
    bottom: 6px;
    left:0px;
  }
  .watermark {
    position: absolute;
    margin:auto;
    width:100%;
    /* left:50%; */
    color: #bababa;
    font-style: italic;
    text-align: center;
    text-shadow:0px 0px 1px rgb(184, 255, 170);
  }
  .watermark:hover {
    display: none;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/WebFormTaxPay/components/signature.vue